module.exports = __webpack_public_path__ + "static/media/fUNI.31719a0d.png";